/**
 * handle favorites js
 * add or remove products and recipes from a user's favorites
 *
 */
(function ($) {
    SoyVay.handleFavorite = (function () {
        function privateInit() {
            const cookieName = 'favoriteRecipes';
            const favoritesCookie = SoyVay.readCookie(cookieName);
            const favoritesArray = favoritesCookie ? JSON.parse(favoritesCookie) : [];
            const cookieDays = 365;
            const handleFavorite = $('.js-handle-favorite');

            // Iterate through recipes, and see if there's a match in favoritesArray
            handleFavorite.each(function () {
                if (favoritesArray.includes($(this).data('id'))) {
                    toggleFavoriteButton($(this), false);
                }
            });

            // controls changing add or remove info in favorite-button.twig
            // optionally update the user's cookie
            function toggleFavoriteButton(button, update) {
                const thisIndex = favoritesArray.indexOf(button.data('id'));
                // remove from favorites
                if (button.hasClass('favorite-badge-favorited')) {
                    button.removeClass('favorite-badge-favorited');
                    button.children('.recipe-status-text').html('Favorite');
                    if (update && thisIndex > -1) {
                        favoritesArray.splice(thisIndex, 1);
                        SoyVay.createCookie(cookieName, JSON.stringify(favoritesArray), cookieDays, false);
                    }
                    // add to favorites
                } else if (!button.hasClass('favorite-badge-favorited')) {
                    button.addClass('favorite-badge-favorited');
                    button.children('.recipe-status-text').html('Unfavorite');
                    if (update && thisIndex === -1) {
                        favoritesArray.push(button.data('id'));
                        SoyVay.createCookie(cookieName, JSON.stringify(favoritesArray), cookieDays, false);
                    }
                }
            }

            const favoriteHandler = function (el, e) {
                // don't click through to the recipe
                e.stopPropagation();
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
                // Toggle selection as soon as user clicks
                toggleFavoriteButton($(el), true);
            };

            handleFavorite.bind('click touchend', function (e) {
                favoriteHandler(this, e);
            });
            handleFavorite.keydown(function (e) {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    favoriteHandler(this, e);
                }
            });
        }

        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.handleFavorite.init();
    });
})(jQuery);
